// @ts-nocheck

const DELIMITADORES = [",", ";", "\t", "|"];

const contarFueraDeComillas = (texto, caracter) => {
    let dentroDeComillas = false;
    let cantidad = 0;
    for (let i = 0; i < texto.length; i++) {
        const actual = texto[i];
        if (actual === '"') dentroDeComillas = !dentroDeComillas;
        else if (actual === caracter && !dentroDeComillas) cantidad++;
    }
    return cantidad;
};

const detectarDelimitador = (texto) => {
    const primeraLinea = texto.split(/\r?\n/).find((linea) => linea.trim()) ?? "";
    return DELIMITADORES.reduce(
        (mejor, delimitador) =>
            contarFueraDeComillas(primeraLinea, delimitador) >
            contarFueraDeComillas(primeraLinea, mejor)
                ? delimitador
                : mejor,
        ","
    );
};

/**
 * Parsea un CSV respetando comillas dobles y saltos de línea dentro de celdas.
 * Devuelve una matriz de filas con sus celdas ya sin espacios ni comillas.
 */
const parsearFilas = (texto, delimitador) => {
    const filas = [];
    let fila = [];
    let celda = "";
    let dentroDeComillas = false;

    for (let i = 0; i < texto.length; i++) {
        const actual = texto[i];

        if (dentroDeComillas) {
            if (actual === '"') {
                if (texto[i + 1] === '"') {
                    celda += '"';
                    i++;
                } else dentroDeComillas = false;
            } else celda += actual;
            continue;
        }

        if (actual === '"') dentroDeComillas = true;
        else if (actual === delimitador) {
            fila.push(celda.trim());
            celda = "";
        } else if (actual === "\n" || actual === "\r") {
            if (actual === "\r" && texto[i + 1] === "\n") i++;
            fila.push(celda.trim());
            filas.push(fila);
            fila = [];
            celda = "";
        } else celda += actual;
    }

    fila.push(celda.trim());
    filas.push(fila);

    return filas.filter((f) => f.some((c) => c !== ""));
};

/**
 * Extrae los correos de un contenido CSV.
 * Descarta la primera fila si es un encabezado (ninguna de sus celdas tiene "@").
 * De las filas con varias columnas (por ejemplo nombre, apellido, correo) toma sólo
 * las celdas candidatas a correo; el resto se devuelve tal cual para que quien lo
 * llame las valide y reporte las que estén mal escritas.
 */
export const parsearCSVEmails = (contenido) => {
    const texto = contenido.replace(/^﻿/, "");
    if (!texto.trim()) return [];

    const filas = parsearFilas(texto, detectarDelimitador(texto));
    if (filas.length === 0) return [];

    const primeraFilaEsEncabezado = !filas[0].some((celda) => celda.includes("@"));
    const filasConDatos = primeraFilaEsEncabezado ? filas.slice(1) : filas;

    return filasConDatos.flatMap((fila) => {
        const celdas = fila.filter((celda) => celda !== "");
        if (celdas.length <= 1) return celdas;
        return celdas.filter((celda) => celda.includes("@"));
    });
};
